import { atom } from "jotai";
import { atomFamily } from "jotai/utils";

import {
  currentBookingAtom,
  currentSessionMemberShipTypeIdAtom,
  currentSessionUserClientIdAtom,
  defaultMembershipTypeIdAtom,
  originalBookingAtom,
} from "../../stores";
import { getRoundFromIdAtom } from "../getRoundFromIdAtom/getRoundFromIdAtom";

export const getMembershipTypeIdFromRoundIdAtom = atomFamily(
  (roundId: string) => {
    return atom((get) => {
      const round = get(getRoundFromIdAtom(roundId));
      const defaultMembershipTypeId = get(defaultMembershipTypeIdAtom);
      const sessionMembershipTypeId = get(currentSessionMemberShipTypeIdAtom);
      if (!round) return null;

      if (round.player.clientType === "customer") {
        return round.player.membershipTypeId;
      }

      if (round.player.clientType === "unknownCustomer") {
        return defaultMembershipTypeId ?? sessionMembershipTypeId;
      }

      const sessionClientId = get(currentSessionUserClientIdAtom);
      if (round.player.clientType === "member") {
        const originalRound = get(originalBookingAtom)?.rounds.find(
          (bookingRound) => bookingRound.serverId === round.serverId
        );
        const originalMembershipTypeId =
          originalRound?.player.clientType === "member"
            ? originalRound.player.membershipTypeId
            : null;

        return (
          round.player.membershipTypeId ??
          originalMembershipTypeId ??
          (round.player.id === sessionClientId ? sessionMembershipTypeId : null)
        );
      }

      if (round.player.clientType === "memberHold") {
        return sessionMembershipTypeId;
      }

      const hostId = round.hostId;
      const hostRound = hostId
        ? [get(currentBookingAtom), get(originalBookingAtom)]
            .flatMap((booking) => booking?.rounds ?? [])
            .find(
              (bookingRound) =>
                bookingRound.player.id === hostId &&
                "membershipTypeId" in bookingRound.player &&
                bookingRound.player.membershipTypeId
            )
        : null;

      return (
        (hostRound && "membershipTypeId" in hostRound.player
          ? hostRound.player.membershipTypeId
          : null) ??
        (hostId && hostId === sessionClientId ? sessionMembershipTypeId : null)
      );
    });
  }
);
